import {
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogTrigger,
    DialogBody,
    Button,
    Spinner,
    makeStyles
} from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import { Base_Url, auth } from "../services/firebase";

// Custom styles
const useStyles = makeStyles({
    spinnerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px', // Adjust height to vertically center the spinner nicely
    }
});

function RSVPConfirmationDialog(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [guestinfo, setGuestInfo] = useState(null);
    const styles = useStyles();

    useEffect(() => {
        setIsLoading(props.isLoading);
        setGuestInfo(props.memberdetail.noOfGuest);
    }, [props.isLoading]);
    const RSVPEvent = () => {
        setIsLoading(true)
        props.onRSVPYes();
    };

       useEffect(() => {
        setIsLoading(props.isLoading);
    }, [props.isLoading]);
    const onRSVPWithoutCharge = () => {
        setIsLoading(true)
        props.onRSVPWithoutCharge();
    };

    return (
        <Dialog
            open={props.isRSVPConfirmDialogOpen}
            onOpenChange={(event, data) => {
                props.setIsOpen(data.open);
            }}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{props.text}</DialogTitle>

                    <DialogContent>
                    {isLoading ? (
                        <div className={styles.spinnerContainer}>
                        <div style={{ textAlign: 'center' }}>
                            <Spinner label="Loading..." />
                            {props.isCharge ? (
                            <p style={{ marginTop: '1rem' }}>
                                Please don't close the dialog while processing payment...
                            </p>
                            ) : null}
                        </div>
                        </div>
                    ) : (
                       props.subtext 
                    )}
                    </DialogContent>
                  
{!isLoading && (
  <DialogActions style={{ display: "flex", gap: "12px", justifyContent: "flex-end", whiteSpace: "nowrap" }}>
    <DialogTrigger disableButtonEnhancement>
      <Button appearance="secondary" style={{ whiteSpace: "nowrap" }}>Cancel</Button>
    </DialogTrigger>
    <Button appearance="primary" onClick={RSVPEvent} style={{ whiteSpace: "nowrap" }}>
      Confirm With Charge
    </Button>
    <Button appearance="primary" onClick={onRSVPWithoutCharge} style={{ whiteSpace: "nowrap" }}>
      Confirm Without Charge
    </Button>
  </DialogActions>
)}

                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default RSVPConfirmationDialog;
